type Props = {
  width?: string;
  height?: string;
  fillColor?: string;
};

/** Six-dot grip marking a row as draggable. */
export default function DragHandleIcon({
  width = '10',
  height = '16',
  fillColor = 'currentColor',
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {[4, 8, 12].map(y => (
        <g key={y}>
          <circle cx="2" cy={y} r="1" fill={fillColor} />
          <circle cx="8" cy={y} r="1" fill={fillColor} />
        </g>
      ))}
    </svg>
  );
}
